import React from 'react';
import { MailIcon, PhoneIcon } from 'lucide-react';
export const TeamSection = () => {
  return <section id="team" className="py-24 bg-white" data-id="element-331">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-332">
        <div className="text-center mb-16" data-id="element-333">
          <h2 className="text-3xl md:text-5xl font-bold text-[#1E1D14] mb-6 font-serif" data-id="element-334">
            Meet the Team
          </h2>
          <div className="w-24 h-1 bg-[#C4A44A] mx-auto mb-6" data-id="element-335"></div>
          <p className="text-xl text-[#5A5535] max-w-3xl mx-auto font-light leading-relaxed" data-id="element-336">
            Our experienced attorneys are ready to guide you through the gTLD
            application process.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-10 max-w-4xl mx-auto" data-id="element-337">
          {/* Marc H. Trachtenberg */}
          <div className="bg-[#FAF9F5] border border-[#EDE9DB] rounded-sm shadow-sm overflow-hidden" data-id="element-338">
            <div className="aspect-[4/5] overflow-hidden bg-[#1E1D14]" data-id="element-339">
              <img src="https://www.gtlaw.com/-/media/images/team/t/trachtenberg-marc-h/32837largepng.png" alt="Marc H. Trachtenberg" className="w-full h-full object-cover object-top" data-id="element-340" />
            </div>
            <div className="p-8" data-id="element-341">
              <h3 className="text-2xl font-bold text-[#1E1D14] font-serif mb-1" data-id="element-342">
                Marc H. Trachtenberg
              </h3>
              <p className="text-[#C4A44A] font-semibold uppercase tracking-wide text-sm mb-1" data-id="element-343">
                Chair, Internet, Domain Name, eCommerce, and Social Media
                Practice
              </p>
              <p className="text-[#5A5535] text-sm mb-4" data-id="element-344">Aspen · Chicago</p>
              <p className="text-[#3D3A25] leading-relaxed mb-5" data-id="element-345">
                Over 20 years of experience handling intellectual property,
                domain name, internet, and technology-related issues. Described
                by <em data-id="element-346">World Trademark Law Review</em> as a "world-leading
                expert on domain names."
              </p>
              <div className="space-y-3" data-id="element-347">
                <a href="mailto:trachtenbergm@gtlaw.com" className="flex items-center text-[#3D3A25] hover:text-[#C4A44A] transition-colors text-sm" data-id="element-348">
                  <MailIcon className="h-4 w-4 mr-3 text-[#C4A44A]" data-id="element-349" />
                  trachtenbergm@gtlaw.com
                </a>
                <a href="tel:+19703005313" className="flex items-center text-[#3D3A25] hover:text-[#C4A44A] transition-colors text-sm" data-id="element-350">
                  <PhoneIcon className="h-4 w-4 mr-3 text-[#C4A44A]" data-id="element-351" />
                  +1 970.300.5313
                </a>
              </div>
              <a href="https://www.gtlaw.com/en/professionals/t/trachtenberg-marc-h" target="_blank" rel="noopener noreferrer" className="inline-block mt-6 text-sm font-bold uppercase tracking-wider text-[#5A5535] hover:text-[#C4A44A] transition-colors border-b border-[#D4C88A] pb-0.5" data-id="element-352">
                View Full Profile
              </a>
            </div>
          </div>

          {/* Phillip V. Marano */}
          <div className="bg-[#FAF9F5] border border-[#EDE9DB] rounded-sm shadow-sm overflow-hidden" data-id="element-353">
            <div className="aspect-[4/5] overflow-hidden bg-[#1E1D14]" data-id="element-354">
              <img src="https://www.gtlaw.com/-/media/images/team/m/marano_phillip/marano_phillip_large.png" alt="Phillip V. Marano" className="w-full h-full object-cover object-top" data-id="element-355" />
            </div>
            <div className="p-8" data-id="element-356">
              <h3 className="text-2xl font-bold text-[#1E1D14] font-serif mb-1" data-id="element-357">
                Phillip V. Marano
              </h3>
              <p className="text-[#C4A44A] font-semibold uppercase tracking-wide text-sm mb-1" data-id="element-358">
                Of Counsel
              </p>
              <p className="text-[#5A5535] text-sm mb-4" data-id="element-359">Washington, D.C.</p>
              <p className="text-[#3D3A25] leading-relaxed mb-5" data-id="element-360">
                Over 15 years advising clients on legal matters at the
                intersection of intellectual property and the Internet, with a
                focus in cybersecurity, entertainment, domain name, and
                technology sectors.
              </p>
              <div className="space-y-3" data-id="element-361">
                <a href="mailto:maranop@gtlaw.com" className="flex items-center text-[#3D3A25] hover:text-[#C4A44A] transition-colors text-sm" data-id="element-362">
                  <MailIcon className="h-4 w-4 mr-3 text-[#C4A44A]" data-id="element-363" />
                  maranop@gtlaw.com
                </a>
                <a href="tel:+12023313165" className="flex items-center text-[#3D3A25] hover:text-[#C4A44A] transition-colors text-sm" data-id="element-364">
                  <PhoneIcon className="h-4 w-4 mr-3 text-[#C4A44A]" data-id="element-365" />
                  +1 202.331.3165
                </a>
              </div>
              <a href="https://www.gtlaw.com/en/professionals/m/marano-phillip-v" target="_blank" rel="noopener noreferrer" className="inline-block mt-6 text-sm font-bold uppercase tracking-wider text-[#5A5535] hover:text-[#C4A44A] transition-colors border-b border-[#D4C88A] pb-0.5" data-id="element-366">
                View Full Profile
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
};